export default __webpack_public_path__ + "static/media/chat-image.266b20fc.jpg";